exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field--box.v-text-field--single-line input{margin-top:0!important}.v-small-dialog__actions button.v-btn{color:#01579b!important;caret-color:#01579b!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/TabVerificaAuto.vue?vue&type=style&index=0&lang=scss&
// module id = 836
// module chunks = 0